import { PressionResultatItem } from './pression-resultat-item.model';
import { ArrayClassConverterFactory } from 'src/app/core/services/mapper/data-property.converter';

export class PressionResultat {
    static jsonMap = {
        objectif: 'objectif',
        realise: 'realise',
        resteAFaire: 'resteAFaire',
        pressionResultatList: { key: 'pressionResultatList', converter: new (ArrayClassConverterFactory.build(PressionResultatItem))() }
    };

    objectif: number;
    realise: number;
    resteAFaire: number;
    pressionResultatList: PressionResultatItem[] = [];
}
